import { api } from '@api/api2';

const getData = () => api.v4('get', 'personal-account/type/list');

export const apiRequests = { getData };
